import { useMemo, useState } from 'react'
import './index.css'
import { DuplicateRow, MetaEntry } from '../../lib/types'
import getId from '../../lib/get-id'
import { Table, TableBatchAction, TableBatchActions, TableBody, TableCell, TableContainer, TableHead, TableHeader, TableRow, TableSelectAll, TableSelectRow, TableToolbar } from '@carbon/react'
import { TrashCan } from '@carbon/icons-react'
import DangerModal from '../modal/DangerModal'
import auth from '../../lib/auth'



type Props = {
    duplicates: Array<DuplicateRow>
    data: Array<any>
    meta: Array<MetaEntry>
    selectedRow: DuplicateRow[]
    handleSelectRow: (duplicate: DuplicateRow) => void
    handleSelectAll: () => void
    handleCancel: () => void
    deleteDuplicate: () => void
}

function render(value: any) {
    if (typeof value === 'boolean')
        return <span className='text-blue-600 uppercase text-sm font-medium'>{String(value)}</span>
    return value
}

export default function DuplicatesTable(props: Props) {
    const { data, duplicates, meta, selectedRow, deleteDuplicate, handleCancel, handleSelectRow, handleSelectAll } = props
    const [open, setOpen] = useState(false)
    const isAdmin = useMemo(() => auth.checkRole('admin', 'workflowAdmin'), [])


    const headers = useMemo(() => {
        if (data.length) return Object.keys(data[0]).filter((h) => h !== '_user_')
        return []
    }, [data])

    if (!data.length)
        return (
            <div className='text-gray-600 my-5 text-sm'>
                <em>Nothing to show</em>
            </div>
        )

    function getMarker(duplicate: DuplicateRow | undefined) {
        if (duplicate) {
            const extras = JSON.parse(duplicate.extras)
            if (extras.markedDuplicateBy) {
                return extras.markedDuplicateBy
            } else {
                return 'unknown'
            }
        } else {
            return 'unknown'
        }
    }



    function isChecked(id: number): boolean {
        return selectedRow.some(item => item.id === id)
    }





    return (
        <div className='table-holder'>
            <TableContainer>
                {selectedRow.length > 0 && <TableToolbar>
                    <TableBatchActions shouldShowBatchActions totalSelected={selectedRow.length} onCancel={handleCancel}>
                        <TableBatchAction tabIndex={0} renderIcon={TrashCan} onClick={() => setOpen(true)}>
                            Delete
                        </TableBatchAction>
                    </TableBatchActions>
                </TableToolbar>}
                <Table>
                    <TableHead>
                        <TableRow>
                            {isAdmin && <TableSelectAll checked={duplicates.length === selectedRow.length} id='duplicate-select-all' name='select-all' onSelect={handleSelectAll} />}
                            <TableHeader>Reported By</TableHeader>
                            <TableHeader>Last Updated</TableHeader>
                            <TableHeader>Updated By</TableHeader>
                            {headers.map((header, i) => <TableHeader key={i}>
                                {header}
                            </TableHeader>)}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {duplicates.map((duplicate, i) => {
                            let row = data.find((d) => Number(duplicate.objId) === getId(d))
                            let rowMeta = meta.find((m) => Number(m.objId) === getId(row))
                            if (!rowMeta || !row) {
                                return <></>
                            }

                            let markedAsDuplicateBy = getMarker(duplicate)

                            return (
                                <TableRow key={i}>
                                    {isAdmin && <TableSelectRow checked={isChecked(duplicate.id)} id={row.id} name={row.id} onSelect={() => handleSelectRow(duplicate)} />}
                                    <TableCell>{markedAsDuplicateBy}</TableCell>
                                    <TableCell>
                                        {new Date(rowMeta.reviewFinished).toLocaleDateString()}
                                    </TableCell>
                                    <TableCell>
                                        {rowMeta.username || ''}
                                    </TableCell>
                                    {headers.map((h, i) => (
                                        <TableCell key={i}>{render(row[h])}</TableCell>
                                    ))}
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            <DangerModal open={open} modalLabel='Delete Duplicates' modalHeading='Are you sure you want to delete these duplicate rows?' onSubmit={deleteDuplicate} onClose={() => setOpen(false)} />
        </div>
    )
}
